var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4334_14721)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4334_14721",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13C20 14.78 19.4722 16.5201 18.4832 18.0001C17.4943 19.4802 16.0887 20.6337 14.4442 21.3149C12.7996 21.9961 10.99 22.1743 9.24419 21.8271C7.49836 21.4798 5.89471 20.6226 4.63604 19.364C3.37737 18.1053 2.5202 16.5016 2.17293 14.7558C1.82567 13.01 2.0039 11.2004 2.68508 9.55585C3.36627 7.91131 4.51983 6.50571 5.99987 5.51677C7.47991 4.52784 9.21997 4 11 4V13H20Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 13C20 14.78 19.4722 16.5201 18.4832 18.0001C17.4943 19.4802 16.0887 20.6337 14.4442 21.3149C12.7996 21.9961 10.99 22.1743 9.24419 21.8271C7.49836 21.4798 5.89471 20.6226 4.63604 19.364C3.37737 18.1053 2.5202 16.5016 2.17293 14.7558C1.82567 13.01 2.0039 11.2004 2.68508 9.55585C3.36627 7.91131 4.51983 6.50571 5.99987 5.51677C7.47991 4.52784 9.21997 4 11 4V13H20Z",
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_4334_14721)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_4334_14721",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2C14.1819 2 15.3522 2.23279 16.4442 2.68508C17.5361 3.13738 18.5282 3.80031 19.364 4.63604C20.1997 5.47177 20.8626 6.46392 21.3149 7.55585C21.7672 8.64778 22 9.8181 22 11L13 11V2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 2C14.1819 2 15.3522 2.23279 16.4442 2.68508C17.5361 3.13738 18.5282 3.80031 19.364 4.63604C20.1997 5.47177 20.8626 6.46392 21.3149 7.55585C21.7672 8.64778 22 9.8181 22 11L13 11V2Z",
    stroke: "#03F5AE",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_4334_14721)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4334_14721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.aa3f6aa3ceb24ba3b938c085707e933c.svg";
export { ForwardRef as ReactComponent };